import { render } from "./Footer.vue?vue&type=template&id=17cef926"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/frknalck/Desktop/MySite/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__